import {useCallback, useEffect} from 'react';
import {isIOS} from 'react-device-detect';

export const useSetScreenSize = () => {
  const onResize = useCallback(() => {
    document.documentElement.style.setProperty(
      '--vh',
      `${window.innerHeight * 0.01}px`
    );
    document.documentElement.style.setProperty(
      '--vw',
      `${window.innerWidth * 0.01}px`
    );
  }, []);

  const handleVisualViewportResize = () => {
    if (window.visualViewport) {
      document.documentElement.style.setProperty(
        '--vh',
        `${window.visualViewport.height * 0.01}px`
      );
    }
  };

  useEffect(() => {
    onResize();

    window.addEventListener('resize', onResize);

    if (isIOS && window.visualViewport) {
      window.visualViewport.addEventListener(
        'resize',
        handleVisualViewportResize
      );
    }

    return () => {
      window.removeEventListener('resize', onResize);
      if (isIOS && window.visualViewport) {
        window.visualViewport.removeEventListener(
          'resize',
          handleVisualViewportResize
        );
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
